import React from 'react'
import { SvgComponent } from './type'

export const Help: SvgComponent = (props) => (
  <svg
    {...props}
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.23894 4.14645C7.72424 4.14645 6.47461 5.37705 6.47461 6.91079C6.47461 7.30846 6.79646 7.61129 7.17511 7.61129C7.55376 7.61129 7.87561 7.28944 7.87561 6.91079C7.87561 6.17239 8.48154 5.56645 9.21994 5.56645C9.99624 5.56645 10.5643 6.11545 10.5643 6.85385V6.91064C10.5643 7.32718 10.4507 8.31174 9.10638 8.52004C8.76564 8.57683 8.50044 8.86078 8.50044 9.22054V11.1328C8.50044 11.5304 8.82229 11.8333 9.20094 11.8333C9.57957 11.8333 9.90144 11.5114 9.90144 11.1328V9.78844C11.6812 9.23944 11.9651 7.70571 11.9651 6.85374C12.0032 5.33918 10.7537 4.14648 9.23898 4.14648L9.23894 4.14645Z"
      fill="#4E6280"
    />
    <path
      d="M9.23982 12.6854C8.72859 12.6854 8.33105 13.1019 8.33105 13.5942C8.33105 14.0864 8.74759 14.5029 9.23982 14.5029C9.73205 14.5029 10.1486 14.0864 10.1486 13.5942C10.1486 13.1019 9.73205 12.6854 9.23982 12.6854Z"
      fill="#4E6280"
    />
    <path
      d="M9.23947 0.000152588C4.1464 0.000152588 0 4.14655 0 9.23962C0 14.3327 4.1464 18.4791 9.23947 18.4791C14.3325 18.479 18.4789 14.3327 18.4789 9.23962C18.4789 4.14655 14.3325 0.000152588 9.23947 0.000152588ZM9.23947 17.078C4.92267 17.078 1.40107 13.5564 1.40107 9.23962C1.40107 4.92282 4.92267 1.40122 9.23947 1.40122C13.5563 1.40122 17.0779 4.92282 17.0779 9.23962C17.0588 13.5564 13.5563 17.078 9.23947 17.078Z"
      fill="#4E6280"
    />
  </svg>
)
